exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2JCRII3SrLzUUKqiTZCAW5 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: inherit;\n}\n._1oE9mnYqd-TL4fSjJ7-XqF {\n  height: 1.5rem;\n  margin: 0 0.5rem;\n}\n._18jz9g75raP9euHQ1TFXRt > :last-child {\n  padding-top: 32px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_2JCRII3SrLzUUKqiTZCAW5",
	"logo": "_1oE9mnYqd-TL4fSjJ7-XqF",
	"form": "_18jz9g75raP9euHQ1TFXRt"
};